import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftComponents/SoftButton";
import { useSoftUIController } from "hooks/context";

function SystemAppearance({ user, updateMode }) {

    const [controller] = useSoftUIController();
    const { userPermissions, deviceLayout, appearance } = controller;

    const canAdvancedDevicesEdit = userPermissions.includes('devices-advanced:edit');

    return (
        <SoftBox p={1} sx={{
            height: deviceLayout == 'mobile' ? 'unset' : 'calc(100svh - 12.1rem - 16px)',
            overflowY: 'auto',
            width: deviceLayout == 'mobile' ? 'unset' : 'calc(100svw - 260px - 64px)',
        }}>
            <SoftBox px={{ xxs: 2, lg: 3 }} pb={{ xxs: 2, lg: 3 }} pt={3} sx={{ borderRadius: "1rem" /*, backgroundColor: "#f9f9f9" */ }}>
                <SoftBox mb={3} textAlign="left" display="flex" flexDirection="column">
                    <SoftTypography variant="subtitle3" fontWeight="medium" color="text" display={deviceLayout == 'mobile' ? 'block' : 'none'}>Account Settings</SoftTypography>
                    <SoftTypography variant="h4" fontWeight="bold" color={appearance}>System Visuals</SoftTypography>
                </SoftBox>
                <SoftBox display="flex" flexDirection="column">
                    <SoftTypography pl={0.5} variant="caption" fontWeight="bold" textTransform="uppercase" color={appearance}>
                        Map Appearance
                    </SoftTypography>
                    <SoftBox
                        display="flex"
                        flexDirection={deviceLayout == 'mobile' ? 'column' : 'row'}
                        p={0.5}
                        mt={1}
                        sx={{
                            backgroundColor: "#eceff1",
                            borderRadius: "0.5rem",
                            width: deviceLayout == 'mobile' ? "calc(100% - 8px)" : "fit-content",
                            border: "1px solid #ccc"
                        }}
                    >
                        {["light", "dark", "system", "light-satellite", "dark-satellite"].filter(row => !canAdvancedDevicesEdit ? !row.includes('satellite') : row).map((mode) => (
                            <SoftButton
                                key={mode}
                                variant={user.user.mode === mode ? "gradient" : "text"}
                                color={user.user.mode === mode ? "info" : "secondary"}
                                size="small"
                                sx={{
                                    px: 2,
                                    py: deviceLayout == 'mobile' ? 1 : 0,
                                    borderRadius: "0.5rem",
                                    textTransform: "capitalize",
                                    height: 'auto'
                                }}
                                onClick={() => {
                                    // console.log("Updating mode to:", mode);
                                    if (user.user.mode != mode) {
                                        updateMode(mode);
                                    }
                                }}
                            >
                                {mode.replace("-", " ")}
                            </SoftButton>
                        ))}
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}


SystemAppearance.propTypes = {
    user: PropTypes.object,
    updateMode: PropTypes.func,
}

export default SystemAppearance;